@if (shouldShow) {
<div class="px-6 pt-4">
  <div
    class="flex flex-wrap items-center justify-between gap-4 rounded-lg border px-4 py-3 text-sm"
    [ngClass]="isExpired ? 'border-red-200 bg-red-50 text-red-800' : 'border-yellow-200 bg-yellow-50 text-yellow-800'">
    <div class="flex flex-col">
      <!-- Title -->
      @if (isExpired) {
      <span class="font-semibold">
        {{ 'shared.phaseRenewal.banner.expiredTitle' | translate }}
      </span>
      } @if (!isExpired) {
      <span
        class="font-semibold"
        [innerHTML]="'shared.phaseRenewal.banner.expiringTitle' | translate: { days: currentPhase?.daysRemaining }">
      </span>
      }
      <!-- Body line — keeps the banner compact on desktop but still readable. -->
      @if (isExpired) {
      <span class="text-xs opacity-80">
        {{ 'shared.phaseRenewal.banner.expiredBody' | translate }}
      </span>
      }
    </div>
    <!-- CTA: disabled label when a request is already pending, otherwise clickable. -->
    @if (!pendingRequest) {
    <button
      type="button"
      pButton
      class="p-button-sm"
      [ngClass]="isExpired ? 'p-button-danger' : 'p-button-warning'"
      [label]="'shared.phaseRenewal.banner.requestRenewal' | translate"
      (click)="onRequestRenewal()"></button>
    } @if (pendingRequest) {
    <span class="rounded-full bg-white/60 px-3 py-1 text-xs font-medium">
      {{ 'shared.phaseRenewal.banner.pendingRequest' | translate }}
    </span>
    }
  </div>
</div>
}

<!-- Shared sales-contact modal handles the form + submission. -->
<app-sales-contact-modal
  [visible]="showSalesModal"
  (closed)="onSalesModalClosed()"
  (submitted)="onSalesRequestSubmitted()"></app-sales-contact-modal>
